import React, { useState } from 'react';
import {
  useIntegration,
  useResolvedIntegration
} from 'services/integration/hooks';
import { LoadingIndicator } from 'common/ui/LoadingIndicator';
import { ATS_LOOKUP_LOADING_TITLE } from 'services/integration/constants';
import { CampaignCreationJobDescriptionATS } from 'modules/campaign-creation/components/CampaignCreationJobDescriptionATS';
import { CampaignCreationJobDescriptionNoATS } from 'modules/campaign-creation/components/CampaignCreationJobDescriptionNoATS';
import { Header } from 'common/ui/Header';
import { Paths } from 'services/navigation/paths';
import { useCampaignCreationStore } from 'modules/campaign-creation/stores/useCampaignCreationStore';
import { getTitle } from 'modules/campaign-creation/utils/getTitle';

type CampaignCreationJobDescriptionHeaderProps = {
  title: string;
  subtitle?: string;
};

const CampaignCreationJobDescriptionHeader = ({
  title,
  subtitle
}: CampaignCreationJobDescriptionHeaderProps) => {
  const state = useCampaignCreationStore((store) => store.state);
  const onJobDescriptionBack = useCampaignCreationStore(
    (store) => store.onJobDescriptionBack
  );

  return (
    <Header
      title={title}
      subtitle={subtitle}
      breadcrumbs={[{ name: 'Campaigns', path: Paths.CAMPAIGNS }]}
      currentBreadcrumb={getTitle(state)}
      onBack={() => onJobDescriptionBack()}
    />
  );
};

export const CampaignCreationJobDescriptionStep: React.FC = () => {
  const { isConnected } = useIntegration();
  const { isIntegrationResolved } = useResolvedIntegration();
  const [shouldShowJobDescriptionInput, setShouldShowJobDescriptionInput] =
    useState(false);

  // Wait for the ATS lookup before choosing a view. `isConnected` reads false
  // while the answer is in flight, so branching on it directly gives an ATS org
  // the type-it-in form and then replaces it with the job picker — pulling the
  // form out from under someone who may already be typing into it.
  if (!isIntegrationResolved) {
    return <LoadingIndicator title={ATS_LOOKUP_LOADING_TITLE} />;
  }

  if (isConnected && !shouldShowJobDescriptionInput) {
    return (
      <>
        <CampaignCreationJobDescriptionHeader title="Choose a job" />
        <CampaignCreationJobDescriptionATS
          onAddJobDescription={() => setShouldShowJobDescriptionInput(true)}
        />
      </>
    );
  }

  return (
    <>
      <CampaignCreationJobDescriptionHeader title="Add job information" />
      <CampaignCreationJobDescriptionNoATS />
    </>
  );
};
